import Icon from './icon';
import './styles/index.scss';
export { Icon as default };
